const initialState = {

    //Billing Job Order LiST
    loadingBillingJobOrder: false,
    BillingJobOrder: [],
    BillingJobOrderError: '',

    //Billing Job Order DETAIL
    loadingBillingJobOrderDetail: false,
    BillingJobOrderDetail: {},
    BillingJobOrderDetailError: '',

    //Billing DETAIL
    loadingBillingDetail: true,
    BillingDetail: {},
    BillingDetailError: '',



    //Billing List
    loadingBillingList: true,
    BillingList: [],
    BillingListError: '',
    BillingListCurrentPage: 0,
    BillingListTotalPage: 0,
    BillingListTotalData: 0


}

const AccountMasterReducer = (state = initialState, action) => {
    switch (action.type) {


        //Billing Job Order LiST//
        case 'FIND_BILLING_JOB_ORDER_REQUEST':
            return {
                ...state,
                loadingBillingJobOrder: true,
                BillingJobOrder: [],
                BillingJobOrderError: '',
            };
        case 'FIND_BILLING_JOB_ORDER_SUCCESS':
            return {
                ...state,
                loadingBillingJobOrder: false,
                BillingJobOrder: action.payload.data,

            };
        case 'FIND_BILLING_JOB_ORDER_FAILURE':
            return {
                ...state,
                loadingBillingJobOrder: false,
                BillingJobOrderError: action.payload,
            };
        //Billing Job Order LiST//


        //Billing Job Order Detail//
        case 'FIND_BILLING_JOB_ORDER_DETAILS_REQUEST':
            return {
                ...state,
                loadingBillingJobOrderDetail: true,
                BillingJobOrderDetail: {},
                BillingJobOrderDetailError: '',

            };
        case 'FIND_BILLING_JOB_ORDER_DETAILS_SUCCESS':
            return {
                ...state,
                loadingBillingJobOrderDetail: false,
                BillingJobOrderDetail: action.payload.data,

            };
        case 'FIND_BILLING_JOB_ORDER_DETAILS_FAILURE':
            return {
                ...state,
                loadingBillingJobOrderDetail: false,
                BillingJobOrderDetailError: action.payload,
            };
        //Billing Job Order Detail//

        //Billing Detail//
        case 'FIND_BILLING_DETAILS_REQUEST':
            return {
                ...state,
                loadingBillingDetail: true,
                BillingDetail: {},
                BillingDetailError: '',

            };
        case 'FIND_BILLING_DETAILS_SUCCESS':
            return {
                ...state,
                loadingBillingDetail: false,
                BillingDetail: action.payload.data,

            };
        case 'FIND_BILLING_DETAILS_FAILURE':
            return {
                ...state,
                loadingBillingDetail: false,
                BillingDetailError: action.payload,
            };
        //Billing Detail//


        //Billing List//
        case 'FIND_SALES_BILLING_LIST_REQUEST':
            return {
                ...state,
                loadingBillingList: true,
                BillingList: [],
                BillingListError: '',
                BillingListCurrentPage: 0,
                BillingListTotalPage: 0,
                BillingListTotalData: 0,
            };
        case 'FIND_SALES_BILLING_LIST_SUCCESS':
            return {
                ...state,
                loadingBillingList: false,
                BillingList: action.payload.data,
                BillingListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                BillingListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                BillingListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_SALES_BILLING_LIST_FAILURE':
            return {
                ...state,
                loadingBillingList: false,
                BillingListError: action.payload,
                BillingListCurrentPage: 1,
                BillingListTotalPage: 0,
                BillingListTotalData: 0,
            };
        //Billing List//

        default:
            return state;
    }
}

export default AccountMasterReducer;